/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Hold_NoteInputs */



/**
* | output |
* | --- |
* | "Pedals use hold-to-play: press to start an action, release to stop or pause." |
*
* @param {Options_Pedal_Hold_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_hold_note = /** @type {((inputs?: Options_Pedal_Hold_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Hold_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
	return /** @type {LocalizedString} */ ("Pedals use hold-to-play: press to start an action, release to stop or pause.")
});